/* Copyright 2016-2021
   Kabandy
   Author: Cedric Hoarau
 */

import { ITimeSerialized } from ".";

export module ModelDataModel {
    export interface IModelTimestampsMapping {
        [key: string]: number;
    }
    export module Database {
        export interface IModel {
            tags: {
                userId: string;
                projectId: string;
                modelId: string;
            };
            time: ITimeSerialized;
            content?: {
                fileName?: string;
                fileSize?: string | number;
                uncompressedFileSize?: string | number;
                extension?: string;
                location?: string;
                source?: any;
                accItemId?: any;
                accVersionId?: any;
                accProjectId?: any;
            };
        }

        export interface IModelCreateInfo {
            tags: {
                userId: string;
                projectId: string;
                modelId: string;
            };
            content?: {
                name?: string;
                size?: string | number;
                uncompressedSize?: string | number;
                location?: string;
                source?: any;
                accItemId?: any;
                accVersionId?: any;
                accProjectId?: any;
            };
            time?: ITimeSerialized;
        }
    }

    export module Runtime {
        export interface IModelCopyInfo {
            userId: string;
            projectIdSrc: string;
            modelIdSrc: string;
            projectIdDest: string;
            modelIdDest: string;
        }
    }

    export module Storage {
        export enum EFilename {
            Objects = "file_objects.json",
            Relationships = "file_relationships.json",
            SourceModels = "source_model_ids.json",
            DataExtraction = "file_data_extraction.json",
            Glb = "file.glb",
            D3 = "file_3D.json",
            Filters = "file_filters.json",
            FiltersValuesPhysical = "file_filters_values_physical.json",
            FiltersValuesRoom = "file_filters_values_room.json",
            AutoselectMeasures = "file_autoselect_measures_v1.json"
        }

        export type FilenameKey = keyof typeof EFilename;

        export type IFileUrlMap = {
            [key in FilenameKey]?: string;
        };
    }
}
